<main class="main-container">
  <ng-content></ng-content>
</main>
